module.exports = __webpack_public_path__ + "static/media/rosietech.0bf6debd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rosietech.jpg
// module id = 401
// module chunks = 0